import React from 'react';

/**
 * Rate template with currency formatting
 */
export const RateTemplate: React.FC<{ rate: number | null | undefined }> = ({ rate }) => {
  const value = rate ?? 0;
  return <span>${value.toLocaleString('en-US', { minimumFractionDigits: 2 })}</span>;
};

// Template function for grid column
export const rateTemplate = (props: { rate: number }) => <RateTemplate rate={props.rate} />;

export default RateTemplate;
